/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

export function initFooter() {
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  )
  const footer = document.querySelector('.footer') as HTMLElement | null
  if (!footer || footer.dataset.hydrated) return
  footer.dataset.hydrated = 'true'

  const backToTopButton = document.querySelector('.back-to-top button') as
    | HTMLButtonElement
    | null

  backToTopButton?.addEventListener('click', () => {
    globalThis.scrollTo({
      top: 0,
      behavior: prefersReducedMotion.matches ? 'instant' : 'smooth',
    })
  })
}
